module.exports = __webpack_public_path__ + "img/tuto_internet_way_02_05.023afde2.png";